import {
  getDataSourceByKeys,
  DATA_SOURCE_KEY_MAPPING,
  SMART_PAGE_DEFAULT_VALUES,
} from '@bingads-webui-campaign-react/smart-component-util';

export const proxyReadLogoConfig = ({ i18n, siteConfig }) => {
  const [
    businessName,
    logoImageId,
  ] = getDataSourceByKeys(siteConfig, [
    DATA_SOURCE_KEY_MAPPING.BusinessName,
    DATA_SOURCE_KEY_MAPPING.LogoImageId,
  ]);

  return {
    label: businessName || i18n.getString(SMART_PAGE_DEFAULT_VALUES.BUSINESS_NAME),
    imageId: logoImageId,
  };
};
